import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  viewChild
} from '@angular/core';
import { SmartRequestTypes } from './../../../../core/api/models/smart-request-types';

export class FilterItem {
  public Title?: string = '';
  public Key?: string = '';
  public Checked?: boolean;
  public IsVisible?: boolean;
}

@Component({
    selector: 'app-filter-row',
    templateUrl: './filter-row.component.html',
    styleUrls: ['./filter-row.component.scss'],
    standalone: false
})
export class FilterRowComponent implements OnInit {
  @Input() filterItems: FilterItem[] = [];
  @Input() smartRequestType: SmartRequestTypes;
  readonly chipList = viewChild<ElementRef>('chipList');
  @Output('change') onChange: EventEmitter<FilterItem> =
    new EventEmitter<FilterItem>();
  hideFilters: boolean;
  baseFilterImtes: FilterItem[] = [];
  filtersIsLimited: boolean = false;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    this.handleShowFilters();
  }

  handleShowFilters() {
    this.hideFilters = false;
    this.filtersIsLimited = false;
    this.filterItems.forEach((filterItem) => {
      filterItem.IsVisible = true;
    });

    switch (this.smartRequestType) {
      case SmartRequestTypes.WelcomeForCity:
      case SmartRequestTypes.WelcomeForProvince:
        this.filtersIsLimited = true;
        this.filterItems.forEach((filterItem) => {
          if (
            filterItem.Key != 'Eghamatgah' &&
            filterItem.Key != 'MobilePrefix'
          ) {
            filterItem.IsVisible = false;
            filterItem.Checked = false;
          }
        });
        break;
      case SmartRequestTypes.WelcomeForAirports:
        // this.hideFilters = true;
        this.filtersIsLimited = true;
        this.filterItems.forEach((filterItem) => {
          if (filterItem.Key != 'MobilePrefix') {
            filterItem.IsVisible = false;
            filterItem.Checked = false;
          }
        });
        break;
    }
  }

  toggleItem(key: string, element: any): void {
    var itemToEmmit = null;
    this.filterItems.forEach((item) => {
      if (item.Key == key) {
        itemToEmmit = item;
        item.Checked = !item.Checked;
      }
    });
    if (itemToEmmit != null) {
      this.cd.detectChanges();
      this.onChange.emit(itemToEmmit);
    }
  }

  moveChipList(direction: 1 | -1) {
    if (direction == -1) {
      this.chipList().nativeElement.scrollLeft += 40;
    } else {
      this.chipList().nativeElement.scrollLeft -= 40;
    }
  }
}
